module.exports = __webpack_public_path__ + "static/media/Picture63.37c5b3cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Picture63.png
// module id = 1535
// module chunks = 0